import { Component, OnInit, AfterViewInit, EventEmitter, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { environment } from '../../../environments/environment';
import { LOCAL_VAR, matchValidation, UtilService } from '@app/core';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { InvisibleReCaptchaComponent } from 'ngx-captcha';

@Component({
  selector: 'app-set-password',
  templateUrl: './set-password.component.html',
  styleUrls: ['./set-password.component.scss']
})
export class SetPasswordComponent implements OnInit, AfterViewInit {
  @ViewChild('captchaElem') captchaElem: InvisibleReCaptchaComponent;
  public passwordTextType: boolean;
  public cPasswordTextType: boolean;
  setPasswordForm: FormGroup;
  isLoading = false;
  queryParams: any;
  error: any;
  appname = environment.name;
  applogo = environment.logo;
  siteKey = environment.siteKey;
  public captchaIsLoaded = false;
  public captchaSuccess = false;
  public captchaResponse?: string;
  public captchaIsReady = false;

  public credentials$ = new EventEmitter<Authentication.Credentials>();
  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private cdr: ChangeDetectorRef,
    public utilService: UtilService
  ) {
    this.route.queryParams.pipe().subscribe(params => {
      this.queryParams = params;
    });
    this.createForm();
  }

  ngOnInit() {
    if (this.queryParams && this.queryParams.token) {
      this.setPasswordForm
        .get('activationCode')
        .setValue(this.queryParams.token);
    }

    var domainconfig = JSON.parse(localStorage.getItem(LOCAL_VAR.domainconfig));
    if (domainconfig) {
      if (domainconfig.appLogo) {
        this.applogo = domainconfig.appLogo;
      }
      if (domainconfig.appName) {
        this.appname = domainconfig.appName;
      }
    } 
    this.utilService.clearMissedError();
  }

  private createForm() {
    this.setPasswordForm = this.formBuilder.group(
      {
        activationCode: [''],
        password: [
          '',
          Validators.compose([
            Validators.required,
            Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$#@^$!%*?&()_<>+=?:;"\',./|<>{}\\\\-])[A-Za-z0-9\d$#@^$!%*?&()_<>+=?:;"\',./|<>{}\\\\-].{7,}')])
        ],
        cPassword: [
          '',
          Validators.compose([
            Validators.required,
            Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$#@^$!%*?&()_<>+=?:;"\',./|<>{}\\\\-])[A-Za-z0-9\d$#@^$!%*?&()_<>+=?:;"\',./|<>{}\\\\-].{7,}'
            )])
        ]
      },
      { validator: matchValidation('password', 'cPassword') }
    );
  }

  ngAfterViewInit() {
    $(function() {
      $('.preloader').fadeOut();
    });

    $('#to-recover').on('click', function() {
      $('#loginform').slideUp();
      $('#recoverform').fadeIn();
    });

    this.utilService.updateDomainCss();
  }

  submit(token:any) {
    this.isLoading = true;
    this.authenticationService
      .setPassword(this.setPasswordForm.value)
      .pipe(
        finalize(() => {
          this.setPasswordForm.markAsPristine();
          this.isLoading = false;
        })
      )
      .subscribe(
        (response: any) => {
          if (response) {
            if (response.user) {
              // this.authenticationService
              //   .login({
              //     email: response.user.email,
              //     password: this.setPasswordForm.get('password').value,
              //     token: token
              //   })
              //   .subscribe(
              //     (credentials: Authentication.Credentials) => {
              //       if (credentials.user.userRoleId.slug !== 'customer') {
              //         this.router.navigate(['/products'], {
              //           replaceUrl: true
              //         });
              //       } else {
              //         this.router.navigate(['/claim'], {
              //           replaceUrl: true
              //         });
              //       }
              //     },
              //     (error: any) => {
              //       this.toastrService.warning('something went Wrong');
              //       this.reset();
              //     }
              //   );
              this.toastrService.success('Password created sucessfully');
                this.router.navigate(['/login'], {
                  replaceUrl: true
                });
            } else {
              this.toastrService.warning('something went Wrong');
              this.reset();
            }
          } else {
            this.toastrService.warning('something went Wrong');
            this.reset();
          }
        },
        (error: any) => {
          this.isLoading = false;
          this.reset();
        }
      );
  }

  handleSuccess(captchaResponse: string): void {
    this.captchaSuccess = true;
    this.captchaResponse = captchaResponse;
    this.cdr.detectChanges();
    //console.log(captchaResponse);
    if(captchaResponse){
      this.submit(captchaResponse)
    }
  }

  execute(): void {
    this.captchaElem.execute();
    // this.submit(true);
  }

  reload(): void {
    this.captchaElem.reloadCaptcha();
  }

  reset(): void {
    this.captchaElem.resetCaptcha();
    this.reload();
  }

}
